type NavigationLabels = {
  blog: string;
  updates: string;
  faq: string;
  support: string;
  supportChatbot: string;
};

const LABELS_BY_LOCALE: Record<string, NavigationLabels> = {
  en: { blog: "Blog", updates: "Updates", faq: "FAQ", support: "Support", supportChatbot: "AI Chat" },
  ko: { blog: "블로그", updates: "업데이트", faq: "자주 묻는 질문", support: "지원", supportChatbot: "AI 채팅" },
  ja: { blog: "ブログ", updates: "アップデート", faq: "よくある質問", support: "サポート", supportChatbot: "AIチャット" },
  "zh-cn": { blog: "Blog", updates: "更新", faq: "常见问题", support: "支持", supportChatbot: "AI 聊天" },
  "zh-tw": { blog: "Blog", updates: "更新", faq: "常見問題", support: "支援", supportChatbot: "AI 聊天" },
  es: { blog: "Blog", updates: "Actualizaciones", faq: "Preguntas frecuentes", support: "Soporte", supportChatbot: "Chat de IA" },
  fr: { blog: "Blog", updates: "Mises à jour", faq: "FAQ", support: "Support", supportChatbot: "Chat IA" },
  de: { blog: "Blog", updates: "Updates", faq: "FAQ", support: "Support", supportChatbot: "KI-Chat" },
  it: { blog: "Blog", updates: "Aggiornamenti", faq: "Domande frequenti", support: "Supporto", supportChatbot: "Chat AI" },
  pt: { blog: "Blog", updates: "Atualizações", faq: "Perguntas frequentes", support: "Suporte", supportChatbot: "Chat de IA" },
  ru: { blog: "Blog", updates: "Обновления", faq: "Частые вопросы", support: "Поддержка", supportChatbot: "AI-чат" },
  tr: { blog: "Blog", updates: "Güncellemeler", faq: "Sık Sorulan Sorular", support: "Destek", supportChatbot: "Yapay Zeka Sohbeti" },
  vi: { blog: "Blog", updates: "Cập nhật", faq: "Câu hỏi thường gặp", support: "Hỗ trợ", supportChatbot: "Chat AI" },
  id: { blog: "Blog", updates: "Pembaruan", faq: "Pertanyaan umum", support: "Dukungan", supportChatbot: "Chat AI" },
  th: { blog: "Blog", updates: "อัปเดต", faq: "คำถามที่พบบ่อย", support: "สนับสนุน", supportChatbot: "แชต AI" },
  ar: { blog: "Blog", updates: "التحديثات", faq: "الأسئلة الشائعة", support: "الدعم", supportChatbot: "دردشة الذكاء الاصطناعي" },
  he: { blog: "Blog", updates: "עדכונים", faq: "שאלות נפוצות", support: "תמיכה", supportChatbot: "צ'אט AI" },
  hi: { blog: "Blog", updates: "अपडेट", faq: "अक्सर पूछे जाने वाले सवाल", support: "सहायता", supportChatbot: "AI चैट" },
  fa: { blog: "Blog", updates: "به‌روزرسانی‌ها", faq: "سوالات متداول", support: "پشتیبانی", supportChatbot: "چت هوش مصنوعی" },
  da: { blog: "Blog", updates: "Opdateringer", faq: "Ofte stillede spørgsmål", support: "Support", supportChatbot: "AI-chat" },
  fi: { blog: "Blog", updates: "Päivitykset", faq: "Usein kysytyt kysymykset", support: "Tuki", supportChatbot: "AI-chat" },
  ms: { blog: "Blog", updates: "Kemas kini", faq: "Soalan Lazim", support: "Sokongan", supportChatbot: "Sembang AI" },
  nb: { blog: "Blog", updates: "Oppdateringer", faq: "Ofte stilte spørsmål", support: "Støtte", supportChatbot: "AI-chat" },
  nl: { blog: "Blog", updates: "Updates", faq: "Veelgestelde vragen", support: "Ondersteuning", supportChatbot: "AI-chat" },
  pl: { blog: "Blog", updates: "Aktualizacje", faq: "Najczęściej zadawane pytania", support: "Wsparcie", supportChatbot: "Czat AI" },
  sv: { blog: "Blog", updates: "Uppdateringar", faq: "Vanliga frågor", support: "Support", supportChatbot: "AI-chatt" },
  uk: { blog: "Blog", updates: "Оновлення", faq: "Поширені запитання", support: "Підтримка", supportChatbot: "AI-чат" },
};

const FALLBACK_LABELS = LABELS_BY_LOCALE.en;

const normalizeLocale = (locale: string): string => locale.trim().toLowerCase();

export const getNavigationLabelDefaults = (locale: string): NavigationLabels => {
  const normalized = normalizeLocale(locale);
  const exact = LABELS_BY_LOCALE[normalized];
  if (exact) {
    return exact;
  }

  const base = normalized.split("-")[0];
  return LABELS_BY_LOCALE[base] ?? FALLBACK_LABELS;
};
